const text = `
# Vystavovatelé:

Zároveň máme pre Vás nachystanú **predajnú výstavu** rôznych zaujímavých produktov:
`

const items = [
  {
    name: 'Planeta her',
    img: require('../resources/exhibitors/planeta-her.png'),
    link: 'https://www.planetaher.cz/',
    text: `
Hry prodáváme hlavně proto, že nás je baví hrát. Je to aktivní společenská zábava a je jen na Vás,
jaký druh hraní Vás láká. Existují hry po děti, pro rodiny, pro dospělé, hry na pět minut i na deset hodin.
Hry strategické, hry zábavné, vědomostní, dovednostní.
Hry pro jednoho i hry pro velkou společnost.  
Vydáváme hry, které máme rádi.  
https://www.planetaher.cz/
  `,
  },
  {
    name: 'Odvážni objavitelia',
    img: require('../resources/exhibitors/odvazni-objavitelia.png'),
    link: 'https://www.cardbards.sk',
    text: `
ODVÁŽNI OBJAVITELIA sú slovenská spoločenská hra plná rodinného gúľania, váľania a šantenia.  
Staňte sa aj vy najväčšími hrdinami vašich detí! Čo budete potrebovať? Iba seba, svoje deti,
kúsok miesta na koberci, hravú náladu a hru Odvážni Objavitelia.  
Viac informácií nájdete na [www.cardbards.sk](https://www.cardbards.sk)  
Hru si môžete kúpiť aj priamo na konferencii za 27€/690CZK
    `,
  },
  {
    name: 'Usborne',
    img: require('../resources/exhibitors/independent-usborne-organiser.jpeg'),
    link:
      'https://www.facebook.com/Amazing-English-Books-for-Children-%C3%9A%C5%BEasn%C3%A9-anglick%C3%A9-d%C4%9Btsk%C3%A9-knihy-a-kn%C3%AD%C5%BEky-270863039990234/',
    text: `
Přijďte se s dětmi pokochat těmi nejkrásnějšími anglickými knížkami pro děti a vybrat si tu pravou pro Vás. 

Usborne nabízí knihy rozvíjející pozornost, logické myšlení, kreativitu, fantazii, jemnou motoriku,
slovní zásobu, prohlubují vědomosti a v neposlední řadě podporují výuku angličtiny.
Můžete si vybrat ze slovníků, encyklopedií, příběhů, pohádek, četby, působivých „schovávaček“,
výukových kartiček, atlasů, doplňovaček (doodles, mazes, puzzles, dot to dot..), omalovánek,
knih se samolepkami, kuchařek a mnoho dalších.
    `,
  },
  {
    name: 'Mama faktura',
    img: require('../resources/exhibitors/mama-faktura.jpeg'),
    link: 'https://www.MAMAfaktura.cz',
    text: `
KAŽDÝ návštěvník stánku dostane HODNOTNÝ DÁREK, který udělá radost malým i velkým
(ano, bude to něco z "vlastní zahrádky")

Kompletní nabídku MAMAfaktury.cz najdete na webu. [www.MAMAfaktura.cz](https://www.MAMAfaktura.cz)  
Pokud si chcete být jistí, že Vámi vybraná pomůcka na vás bude na stánku čekat klidně až
do nedělního odpoledne, můžete si ji objednat přes eshop a do poznámky napsat "vyzvednu si
na konferenci v Brně". Na konfereci si pak můžete pomůcku prohlédnout, vyzkoušet a až poté zaplatit.
Tak neváhejte, koukněte na web a rezervujte si vše, co vás zaujalo.
    `,
  },
  {
    name: 'Marionetino',
    img: require('../resources/exhibitors/marionetino.jpeg'),
    link: 'http://www.marionetino.cz/',
    text: `
Loutková divadla pro předškoláky MARIONETINO  
Spousta pohádek, krásné a kvalitní loutky, oceněno odborníky SPRÁVNÁ HRAČKA.

Loutková divadla a hra s nimi jsou bezesporu jednou z mnoha vynikající pomůcek pro rozvoj řeči
a kreativity dítěte. Zaujímají nejen své místo mezi hračkami, které významně přispívají k
celkovému rozvoji dítěte, ale mají velký vliv i na tvorbu a upevňování sociálních vazeb v kolektivu.  
Červená Karkulka, Perníková chaloupka, O Budulínkovi, Boudo Budko, O Koblížkovi,
O neposlušných kůzlátkách a další...
    `,
  },
  {
    name: 'Moji kamarati',
    img: require('../resources/exhibitors/moji-kamarati.jpeg'),
    link: 'http://www.mojikamarati.sk',
    text: `
Prvé detské knižky vydané na Slovensku, vďaka ktorým si vaše deti zamilujú ovocie a zeleninku.
Konečne dáte doma aj brokolicu.  
Vynikajúci nápad dvoch mamičiek oslovil už tisícky detí na Slovensku a teraz sa s nimi zoznámite
aj vy. Predstavíme vám ich na našej konferencii.  
[www.mojikamarati.sk](http://www.mojikamarati.sk)
    `,
  },
  {
    name: 'Socioterapia',
    img: require('../resources/exhibitors/socioterapia.jpeg'),
    link: 'http://www.socioterapia.sk/',
    text: `
Ištitút psychoterapie a societerapie je partnerom našej konferencie a zároveň si priamo
na konferencii budete môcť zakúpiť tieto ich knihy, ktoré sú veľmi dobré - všetky mam doma.

http://www.socioterapia.sk/ 
    `,
  },
  {
    name: 'Naivná pedagogika',
    img: require('../resources/exhibitors/naivna-pedagogika.png'),
    text: `
Juraj Šimkovič predstaví knihu Naivná pedagogika z praxe: "Kniha, ktorú uvádzam na svet hovorí o
tom, čo ma naučili deti.  
O tom, ako byť lepším človekom a lepším pedagógom. Lebo ak ich chcem meniť formovať a
vychovávať, musím najprv pracovať sám na sebe."
    `,
  },
  {
    name: 'Tričká',
    img: require('../resources/exhibitors/tricka.jpg'),
    text: `
Môžete si kúpiť aj naše konferenčné tričká za 10€/250CZK
    `,
  },
]

export default {
  text,
  items,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/exhibitors/list.js